import { defineStore } from "pinia";

export const useSwitchSessionStore = defineStore("switchSession", {
  state: () => ({
    active: false,
  }),
  actions: {
    toggle(active?: boolean) {
      this.active = active === undefined ? !this.active : active;
    },
  },
});
